import { defineStore } from "pinia";
import { ref } from "vue";
import { useWordpressApi } from "~/composables/useWordpressApi";
import type { Category } from "~/types/projects";

export const useStoreCategories = defineStore("categories", () => {
  const categories = ref<Category[]>([]);
  const error = ref<string | null>(null);
  const isLoading = ref(false);
  const { getCategories } = useWordpressApi();

  const fetchCategories = async () => {
    if (categories.value.length > 0) return categories.value;
    isLoading.value = true;
    try {
      const data = await getCategories();
      categories.value = data ?? [];
      return categories.value;
    } catch (err: any) {
      console.error("Erreur lors du fetch des catégories :", err);
      error.value = "Impossible de charger les catégories";
      return [];
    } finally {
      isLoading.value = false;
    }
  };

  return {
    categories,
    error,
    fetchCategories,
    isLoading,
  };
});
